<template>
  <div class="index">
    <headerimg/>
    <!-- 倒计时 -->
    <div class="Countdowntime" style="margin-top: 0.52rem;">
      <div class="Countdown">
        <!-- {{count}} -->
        <div>
          <div class="time-list">
            <p>{{ d }}</p>
          </div>
          <p>DAYS</p>
        </div>
        <span class="fuhao">:</span>
        <div>
          <div class="time-list">
            <p>{{ h }}</p>
          </div>
          <p>HRS</p>
        </div>
        <span class="fuhao">:</span>
        <div>
          <div class="time-list">
            <p>{{ m }}</p>
          </div>
          <p>MINS</p>
        </div>
        <span class="fuhao">:</span>
        <div>
          <div class="time-list">
            <p>{{ s }}</p>
          </div>
          <p>SECS</p>
        </div>
      </div>
      <div class="Countdownmoney">
        <div class="money">
          <p class="test-1">KES {{ parseInt(Params.amount || '0').toLocaleString() }}</p>
          <p class="test-2">Account Reference：{{ Params.merchantOrderId }}</p>
        </div>
      </div>
    </div>
    <!-- 电话号码 -->
    <div class="mobeilphone">
      <div class="mobiletitle">
        <p>Mobile number</p>
      </div>
      <div class="mobile-input" style="margin-top: 0.12rem;">
        <div class="mobile-city">
          <img style="width: 0.4rem; height: 0.4rem;" src="../../assets/images/mpesa/kenniya@2x.png" alt="">
          <span class="test-1">254</span>
        </div>
        <div class="phone-number">
          <input type="number" style="border: none; background: none;" v-model="mobile"></input>
        </div>
      </div>
      <div class="mobiletitle" style="margin-top: 0.24rem;">
        <p>Amount (KES)</p>
      </div>
      <div class="amount" style="margin-top: 0.12rem;">
        <p class="test-1">{{ parseInt(Params.amount || '0').toLocaleString() }}</p>
      </div>

      <!-- <div class="check" style="margin-top: 0.22rem;">
        <input type="checkbox" class="check-box" v-model="checkstatus">
        <p class="test-1">Save my information for faster checkout</p>
      </div> -->

      <div class="btn">
        <button class="btn-click" @click="Payment">Go to Next</button>
      </div>
    </div>
    <!-- 文字信息 -->
    <emailtext></emailtext>

  </div>
</template>

<script>
import md5 from 'js-md5';
import {encryption} from "../../utils/requestUtils";

export default {
  data() {
    return {
      count: '', //倒计时
      d: '',
      h: '',
      m: '',
      s: '',
      seconds: 0, // 10天的秒数

      Params: {},
      UserInfo: {},
      checkstatus: false,
      mobile: '',
      timeer: '',
      payChannelType: '', //二类支付
      request_flag: true,
    }
  },
  validations: {
    mobile: [{
      required: true,
      message: "Mobile number is Must",
      trigger: "blur"
    }, {
      min: 9,
      max: 10,
      message: 'Mobile number length min 9 max 10',
      trigger: 'blur'

    }],
  },
  mounted() {
    this.Time() //调用定时器
    this.getParams()
    this.getUserInfo()
    this.payment()
  },
  beforeDestroy() {
    clearTimeout(this.timeer)
  },
  methods: {
    Payment() {
      // if(this.checkstatus ==false){
      // this.$toast("Fail!")
      // }
      console.log(1)
      if (this.mobile == '') {
        this.$toast("Please enter your mobile number")

        return
      } else if (this.mobile.length < 9 || this.mobile.length > 10) {
        this.$toast("Mobile number length min 9 max 10")

        return
      } else {
        console.log(3)
        this.Params.mobile = this.mobile
        // 二类支付
        if (this.payChannelType === 73) {
          console.log(4)
          console.log(this.List)
          if (!this.request_flag) {
            return
            console.log(5)
          }
          console.log(6)
          // this.$toast('Payment Proceed')
          this.btntext = "Loading...";
          const that = this;
          this.request_flag = false
          this.flag = true // 加载中...
          // const sign = localStorage.getItem('sign')
          const timestamp = new Date().getTime()
          const curURL = '/api/order/submitSecond'
          const data = {
            merchantId: that.Params.merchantId,
            merchantOrderId: that.Params.merchantOrderId,
            amount: that.Params.amount,
            timestamp: timestamp,
            sign: that.Params.sign,
            mobile: that.mobile,
            email: that.Params.email
          }

          this.axios.post(curURL, data).then(res => {
            console.log(res.data.data.status)
            this.$router.push({
              path: '/mpesa/cardNumber',
              query: this.Params
            })

            if (res.data.data.status == 0) {
              // 待支付
              this.flag = false
              this.$toast('Your money will be comfirmed in few minutes')
            } else if (res.data.data.status == 1) {
              // this.$toast('Payment success')
              // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
              if (res.data.data.callbackUrl != '' && res.data.data.callbackUrl.startsWith('http')) {
                window.location.href = res.data.data.callbackUrl
              } else {
                this.$router.push({
                  path: '/mpesa/success',
                  query: this.Params
                })
              }

            } else if (res.data.data.status == 2) {
              // this.$toast('Failure to pay')
              this.$router.push({
                path: '/mpesa/fail',
                query: this.Params
              })
            }
            this.request_flag = true
            this.btntext = 'I have made this payment'
          })


        } else {
          this.$router.push({
            path: '/mpesa/order',
            query: this.Params
          })
        }
        console.log(this.Params)
      }
      console.log(this.checkstatus)
    },
    getParams() {
      // 'merchantId=999&
      // merchantOrderId=1000&
      // amount=100.00&
      // abc#123!'
      this.Params = this.$route.query
      console.log(this.Params)
      // 签名
      const sign = md5(
        `merchantId=${this.Params.merchantId}&merchantOrderId=${this.Params.merchantOrderId}&amount=1${parseInt(this.Params.amount || '0').toLocaleString()}&abc#123!`
      )
      localStorage.setItem('sign', sign)
    },

    getUserInfo() {
      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.Params.merchantId,
          merchantOrderId: this.Params.merchantOrderId
        })
      }).then(res => {
        console.log(res, '123123123123')
        this.payChannelType = res.data.data.payChannelType
        this.Params.transferBank = res.data.data.transferBank
        this.seconds = Number(res.data.data.timeoutSeconds)
      })
    },
    payment() {
      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.Params.merchantId,
          merchantOrderId: this.Params.merchantOrderId
        })
      }).then(res => {
        if (res.data.data.status == 0) {
          if (res.data.data.timeoutSeconds <= 0) {
            this.$router.push({
              path: '/mpesa/fail',
              query: this.Params
            })
          } else {
            this.timeer = setTimeout(() => {
              this.payment()
            }, 3000)
          }

          this.UserInfo = res.data.data
        } else if (res.data.data.status == 1) {
          this.$router.push({
            path: '/mpesa/success',
            query: this.Params
          })
        } else if (res.data.data.status == 2) {
          this.$router.push({
            path: '/mpesa/fail',
            query: this.Params
          })

        }


      })
    },
    // 天 时 分 秒 格式化函数
    countDown() {
      let d = parseInt(this.seconds / (24 * 60 * 60))
      d = d < 10 ? "0" + d : d
      let h = parseInt(this.seconds / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(this.seconds / 60 % 60);
      m = m < 10 ? "0" + m : m
      let s = parseInt(this.seconds % 60);
      s = s < 10 ? "0" + s : s
      this.count = d + '天' + h + '时' + m + '分' + s + '秒'
      this.d = d
      this.h = h
      this.m = m
      this.s = s
    },
    //定时器没过1秒参数减1
    Time() {
      setInterval(() => {
        this.seconds -= 1
        this.countDown()
      }, 1000)
    },
  }
}
</script>

<style lang="scss">
.index {
  background-color: #F5F7FA;
  min-height: 100vh;

  .Countdowntime {
    width: 6.54rem;
    height: 4.04rem;
    background-image: url('../../assets/images/mpesa/bg@3x.png');
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;

    .Countdown {
      width: 3.88rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 0.9rem;
      left: 0;
      right: 0;

      .fuhao {
        font-size: 0.5rem;
      }

      .time-list {
        p {
          width: 0.72rem;
          height: 0.72rem;
          background: #151515;
          background: rgba(0, 0, 0, 0.75);
          border-radius: 0.1rem;
          opacity: 1;
          color: #fff;
          line-height: 0.72rem;
          font-size: 0.36rem;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }

    .Countdownmoney {
      width: 6.54rem;
      height: 1.4rem;

      background-color: #191932;
      position: absolute;
      bottom: 0;
      border-radius: 0 0 22px 22px;

      .money {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 1.4rem;

        .test-1 {
          font-size: 0.4rem;
          font-family: Helvetica-Bold, Helvetica;
          font-weight: bold;
          color: #FFFFFF;
        }

        .test-2 {
          font-size: 0.28rem;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }
  }

  .mobeilphone {
    width: 5.9rem;
    margin: 0 auto;
    background-color: #F0F4F6;
    border-radius: 0.4rem;
    padding: 0.48rem 0.32rem;
    margin-top: 0.4rem;

    .mobiletitle {
      p {
        font-size: 0.28rem;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #151515;
        text-align: left;
      }
    }

    .mobile-input {
      width: 5.9rem;
      height: 0.88rem;
      background: #FFFFFF;
      border-radius: 0.16rem;
      border: 0.02rem solid #C6C6D3;
      display: flex;

      .mobile-city {
        width: 1.6rem;
        height: 0.88rem;
        background: #F3F5F8;
        border-radius: 0.16rem 0rem 0rem 0.16rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .test-1 {
          font-size: 0.28rem;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #151515;
          margin-left: 0.14rem;
        }
      }

      .phone-number {
        font-size: 0.32rem;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #151515;
        line-height: 0.88rem;
        margin-left: 0.24rem;
      }
    }

    .amount {
      width: 5.9rem;
      height: 0.88rem;
      background: #FFFFFF;
      border-radius: 0.16rem;
      border: 0.02rem solid #C6C6D3;

      .test-1 {
        font-size: 0.28rem;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #151515;
        margin-left: 0.24rem;
        text-align: left;
        line-height: 0.88rem;
      }
    }

    .check {
      display: flex;
      justify-content: left;
      align-items: center;

      .check-box {
        width: 0.32rem;
        height: 0.32rem;
      }

      .test-1 {
        font-size: 0.26rem;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #282E34;
      }
    }

    .btn {
      width: 5.9rem;
      height: 1.08rem;
      margin-top: 0.38rem;

      .btn-click {
        width: 5.9rem;
        height: 1.08rem;
        border: none;

        background: linear-gradient(138deg, #8AFFA7 0%, #FEFD42 100%);
        border-radius: 0.16rem;
        font-size: 0.3rem;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #151515;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/index.vue